import React, { useState } from 'react';
import AddCharge from '../AddEdit/AddCharge';
import EditCharge from '../AddEdit/EditCharge';

const ExchangeRateTab= () => {
const [showAdd, setShowAdd] = useState(false);
const handleCloseAdd = () => setShowAdd(false);
const handleShowAdd = () => setShowAdd(true);

const [showEdit, setShowEdit] = useState(false);
const handleCloseEdit = () => setShowEdit(false);
const handleShowEdit = () => setShowEdit(true);

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className="row">

                    <div className="col-md-6 d-flex flex-column">
                        <label className="form-label mb-2">Select Options</label>
                        <div className="checkbox-group">
                        
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="onBoardTruck" />
                                <label className="form-check-label" htmlFor="onBoardTruck">On Board Truck</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="onBoardVessel" />
                                <label className="form-check-label" htmlFor="onBoardVessel">On Board Vessel</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="onDeckRisk" />
                                <label className="form-check-label" htmlFor="onDeckRisk">On Deck at Shipper's
                                    Risk</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="priorDamageRemarks" />
                                <label className="form-check-label" htmlFor="priorDamageRemarks">Prior Damage
                                    Remarks</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="producingOrigin" />
                                <label className="form-check-label" htmlFor="producingOrigin">Producing Country of
                                    Origin</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="receivedShipment" />
                                <label className="form-check-label" htmlFor="receivedShipment">Received For
                                    Shipment</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="refrigeratedCargo" />
                                <label className="form-check-label" htmlFor="refrigeratedCargo">Refrigerated
                                    Cargo</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="seaWaybill" />
                                <label className="form-check-label" htmlFor="seaWaybill">Sea Waybill</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="seaAirCargo" />
                                <label className="form-check-label" htmlFor="seaAirCargo">Sea-Air Cargo</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="shippersLoadCount" />
                                <label className="form-check-label" htmlFor="shippersLoadCount">Shipper's Load and
                                    Count</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="shortShipped" />
                                <label className="form-check-label" htmlFor="shortShipped">Short-Shipped</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="titleClause" />
                                <label className="form-check-label" htmlFor="titleClause">Title Passage Clause</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="vesselFreezing" />
                                <label className="form-check-label" htmlFor="vesselFreezing">Vessel Not Responsible for
                                    Freezing</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="freightAgreed" />
                                <label className="form-check-label" htmlFor="freightAgreed">Freight as Agreed</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="freightCollect" />
                                <label className="form-check-label" htmlFor="freightCollect">Freight Collect</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="freightPrepaid" />
                                <label className="form-check-label" htmlFor="freightPrepaid">Freight Prepaid</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="gatt" />
                                <label className="form-check-label" htmlFor="gatt">
                                    General Agreement on Tariff and Trade (GATT)
                                </label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="gsp" />
                                <label className="form-check-label" htmlFor="gsp">General System of Preferences
                                    (GSP)</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="imoCertification" />
                                <label className="form-check-label" htmlFor="imoCertification">
                                    International Maritime Organization Certification
                                </label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="israelFreeTrade" />
                                <label className="form-check-label" htmlFor="israelFreeTrade">Israeli Free Trade
                                    Agreement</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="ladenOnBoard" />
                                <label className="form-check-label" htmlFor="ladenOnBoard">Laden on Board</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="memoBill" />
                                <label className="form-check-label" htmlFor="memoBill">Memo Bill of Lading Only</label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="nafta" />
                                <label className="form-check-label" htmlFor="nafta">
                                    North American Free Trade Agreement (NAFTA)
                                </label>
                            </div>
                            <div className="form-check">
                                <input type="checkbox" className="form-check-input" id="onBoardContainer" />
                                <label className="form-check-label" htmlFor="onBoardContainer">On Board
                                    Container</label>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        {/* <div className="py-2">
            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                <button className="btn btn-primary text-xs" type="button">
                    Insert Default
                </button>

            </div>
        </div> */}

    </form>

</>
);
};

export default ExchangeRateTab;